import { useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../config/Axios';
import { useCustomToast } from '../pages/Contexts/ToastContext';

const KEY = 'screensList';

export const useGetScreens = (params = {}, options = {}) => {
  const { showToast } = useCustomToast();
  return useQuery(
    [KEY, params],
    async ({ queryKey }) => (await axiosInstance.get('/screens', { params: queryKey[1] })).data,
    {
      keepPreviousData: true,
      onError: (err) => showToast('error', 'Screens', err.response?.data?.message),
      ...options,
    }
  );
};

export const useCreateScreen = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((payload) => axiosInstance.post('/screens/create', payload), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      showToast('success', 'Screens', 'Screen created!');
    },
    onError: (err) => showToast('error', 'Screens', err.response?.data?.message),
  });
};

export const useUpdateScreen = (id) => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((payload) => axiosInstance.put(`/screens/${id}/update`, payload), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      showToast('success', 'Screens', 'Screen updated!');
    },
    onError: (err) => showToast('error', 'Screens', err.response?.data?.message),
  });
};

export const useDeleteScreen = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((id) => axiosInstance.delete(`/screens/${id}/delete`), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      showToast('success', 'Screens', 'Screen removed!');
    },
    onError: (err) => showToast('error', 'Screens', err.response?.data?.message),
  });
};
